import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import APIDataFetchLoader from "../../../Others/APIDataFetchLoader";
import NewsPaperAddValidation from "./NewsPaperAddValidation";
import Sidebar from "../../Sidebar";
import DeshbordBreadcrumb from "../../Breadcrumb/DeshbordBreadcrumb";
import DeshBoardFooter from "../../DeshBoardFooter";
import NotifyMessageNoReload from "../../../Others/NotifyMessageNoReload";
import { useAuth } from "../../../../Store/AuthContext";
import { Helmet } from "react-helmet";
import "./NewsPaperCSS.css";

const SiteUrl = process.env.REACT_APP_SITEURL;
const WebsiteAPIurl = SiteUrl + "api/Webapi/";

export default function NewsPaperAdd() {
  const { userID, RendomTokenfetch, userRoll, vendorRollID } = useAuth();
  const navigate = useNavigate();

  // console.log(statusPriority);

  const [categories, setCategories] = useState([]);

  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);

  const [selectedCategory, setSelectedCategory] = useState("");

  const [selectedState, setSelectedState] = useState("");
  const [selectedcity, setSelectedcity] = useState("");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  // const [CatLoading, setCatLoading] = useState(false);

  const [formValiderror, setformValiderror] = useState({});
  // const [categoryError, setCategoryError] = useState(false);

  // Fetch categories on component mount

  // const loadCategories = async (inputValue) => {
  //   const fdata = new FormData();
  //   fdata.append("userid", userID);

  //   const response = await axios.post(
  //     `${WebsiteAPIurl}fetchNewspaperCategory`,
  //     fdata,
  //     {
  //       headers: { Authorization: RendomTokenfetch },
  //     }
  //   );

  //   if (response.data.Status === "1") {
  //     const data = response.data.newscategory || [];
  //     setCategories(data);
  //     const filtered = response.data.newscategory.filter((cat) =>
  //       cat.cat_name.toLowerCase().includes(inputValue.toLowerCase())
  //     );
  //     return filtered.map((cat) => ({
  //       label: cat.cat_name,
  //       value: cat.cat_id,
  //     }));
  //   } else {
  //     return [];
  //   }
  // };

  // Fetch States
  useEffect(() => {
    setLoading(true);
    const FetchStateData = async () => {
      try {
        await axios
          .get(`${WebsiteAPIurl}getAllState`, {
            params: { country_id: "101" },
          })
          .then((response) => {
            // console.log("API Response:", response.data);
            if (response.data.Status === "1") {
              setStates(response.data.allstateData || []);
              setCities([]);
            } else {
              setStates([]);
              setCities([]);
            }
          });
      } catch (err) {
        setError(err.message);
        // console.error('Error:', err.response ? err.response.data : err.message);
      } finally {
        setLoading(false);
      }
    };
    FetchStateData();
  }, [RendomTokenfetch]);

  // Fetch Cities
  useEffect(() => {
    setLoading(true);
    const FetchCityData = async () => {
      try {
        await axios
          .get(`${WebsiteAPIurl}getAllCity`, {
            params: { state_id: selectedState },
          })
          .then((response) => {
            // console.log("API Response:", response.data);
            if (response.data.Status === "1") {
              setCities(response.data.allcityData || []);
            }
            if (response.data.Status === "0") {
              setCities([]);
            }
          });
      } catch (err) {
        setError(err.message);
        // console.error('Error:', err.response ? err.response.data : err.message);
      } finally {
        setLoading(false);
      }
    };
    FetchCityData();
  }, [RendomTokenfetch, selectedState]);

  // Fetch News Category
  useEffect(() => {
    setLoading(true);
    let fdata = new FormData();
    fdata.append("state_id", selectedState);
    const FetchCityData = async () => {
      try {
        await axios
          .post(`${WebsiteAPIurl}get_state_related_data`, fdata, {
            headers: {
              Authorization: RendomTokenfetch,
            },
          })

          .then((response) => {
            // console.log("API Response newsdata:", response.data);
            if (response.data.Status === "1") {
              setCategories(response.data.newsdata || []);
            }
            if (response.data.Status === "0") {
              setCategories([]);
            }
          });
      } catch (err) {
        setError(err.message);
        // console.error('Error:', err.response ? err.response.data : err.message);
      } finally {
        setLoading(false);
      }
    };
    FetchCityData();
  }, [RendomTokenfetch, selectedState]);

  const [newspaperName, setnewspaperName] = useState("");
  const [sentpublishdate, setSentpublishdate] = useState("");
  const [description, setdescriptions] = useState("");

  const [newsdetails, setnewsdetails] = useState([
    { adsFormate: "", lines: "0", words: "0" },
  ]);

  const handleInputChange = (index, field, value) => {
    const updated = [...newsdetails];
    updated[index][field] = value;

    if (field === "adsFormate") {
      const text = value.trim();
      updated[index].lines =
        text === "" ? "0" : text.split("\n").length.toString();
      updated[index].words =
        text === "" ? "0" : text.split(/\s+/).length.toString();
    }

    setnewsdetails(updated);
  };

  const addCourtRow = () => {
    setnewsdetails([
      ...newsdetails,
      { adsFormate: "", lines: "0", words: "0" },
    ]);
  };

  const removeCourtRow = (index) => {
    if (newsdetails.length > 1) {
      const updated = newsdetails.filter((_, i) => i !== index);
      setnewsdetails(updated);
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    let fdata = new FormData();
    fdata.append("userid", userID);
    fdata.append("role_id", userRoll);
    fdata.append("vendor_role", vendorRollID);
    fdata.append("newspaper_name", newspaperName);
    fdata.append("sent_publish_date", sentpublishdate);
    fdata.append("news_category", selectedCategory);
    fdata.append("state_id", selectedState);
    fdata.append("city_id", selectedcity);
    fdata.append("description", description);
    newsdetails.forEach((item, index) => {
      fdata.append(`ads_formate[${index}]`, item.adsFormate);
      fdata.append(`lines[${index}]`, item.lines);
      fdata.append(`words[${index}]`, item.words);
    });

    //  const adsformateArray = newsdetails.map((itemRow) => itemRow.adsFormate);
    //   const linesArray = newsdetails.map((itemRow) => itemRow.lines);
    //   const wordsArray = newsdetails.map((itemRow) => itemRow.words);

    //   // Append arrays to FormData
    //   fdata.append("ads_formate", adsformateArray);
    //   fdata.append("lines", linesArray);
    //   fdata.append("words", wordsArray);

    axios
      .post(`${WebsiteAPIurl}add_newspaperAds`, fdata, {
        headers: {
          Authorization: RendomTokenfetch,
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        if (newspaperName && selectedCategory) {
          if (response.data.Status === "0") {
            NotifyMessageNoReload(response.data.message, "danger");
            setformValiderror(
              NewsPaperAddValidation(response.data.form_validation)
            );
          }

          if (response.data.Status === "1") {
            NotifyMessageNoReload(response.data.message, "success");
            navigate("/news-paper-add-view");
          }
        } else {
          setformValiderror(
            NewsPaperAddValidation(response.data.form_validation)
          );
        }
      });
  };

  if (loading) {
    return <APIDataFetchLoader />;
  }
  if (error) {
  }

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow"></meta>
      </Helmet>
      <div className="page-wrapper dashboard mm-page mm-slideout" id="mm-0">
        <Sidebar />
        <DeshbordBreadcrumb page1={[{ name: "Vendor Lead Add" }]} />
        <section className="user-dashboard">
          <div className="dashboard-outer">
            <div className="row">
              <div className="col-lg-12">
                <div className="ls-widget">
                  <div className="tabs-box">
                    {/* <div className="widget-title">
                      <h3>Lead Add</h3>
                    </div> */}
                    <div className="widget-content py-4">
                      <form className="was-validated" onSubmit={handleSubmit}>
                        <div className="row">
                          <div className="form-group col-lg-4 col-md-6 col-sm-12 mb-3">
                            <label htmlFor="name">News Paper Name</label>
                            <input
                              type="text"
                              value={newspaperName}
                              onChange={(e) => setnewspaperName(e.target.value)}
                              className="form-control"
                              required
                            />
                            <div className="invalid-feedback">
                              {formValiderror.newspaper_name &&
                                formValiderror.newspaper_name}
                            </div>
                          </div>

                          <div className="form-group col-lg-4 col-md-6 col-sm-12 mb-3">
                            <label>State</label>
                            <select
                              className="form-control"
                              value={selectedState}
                              onChange={(e) => setSelectedState(e.target.value)}
                              required
                            >
                              <option value="">Select State</option>
                              {states.map((state) => (
                                <option value={state.id} key={state.id}>
                                  {state.name}
                                </option>
                              ))}
                            </select>
                            <div className="invalid-feedback">
                              {formValiderror.state_id &&
                                formValiderror.state_id}
                            </div>
                          </div>

                          <div className="form-group col-lg-4 col-md-6 col-sm-12 mb-3">
                            <label>City</label>
                            <select
                              className="form-control"
                              value={selectedcity}
                              onChange={(e) => setSelectedcity(e.target.value)}
                              disabled={!cities.length}
                              required={cities.length}
                            >
                              <option value="">Select City</option>
                              {cities.map((city) => (
                                <option value={city.id} key={city.id}>
                                  {city.name}
                                </option>
                              ))}
                            </select>
                            <div className="invalid-feedback">
                              {formValiderror.city_id && formValiderror.city_id}
                            </div>
                          </div>

                          <div className="form-group col-lg-4 col-md-6 col-sm-12 mb-3">
                            <label>News Category</label>
                            <select
                              className="form-control"
                              value={selectedCategory}
                              onChange={(e) =>
                                setSelectedCategory(e.target.value)
                              }
                              disabled={!categories.length}
                            >
                              <option value="">Select News</option>
                              {categories.map((datanews) => (
                                <option value={datanews.id} key={datanews.id}>
                                  {datanews.newspapername}
                                </option>
                              ))}
                            </select>
                          </div>

                          <div className="form-group col-lg-4 col-md-6 col-sm-12 mb-3">
                            <label htmlFor="Date">Sent Publication Date</label>
                            <input
                              type="date"
                              className="form-control"
                              name="sentpublishdate"
                              value={sentpublishdate}
                              onChange={(e) =>
                                setSentpublishdate(e.target.value)
                              }
                            />
                          </div>

                          {/*****************News Details Addmore Working**********************/}
                          <div className="headingBOXing d-flex mb-3">
                            <h6 className="fw-600 ">News Formates</h6>
                            <div className="addremovebtnbox d-flex">
                              ({" "}
                              <span
                                className="px-1 AddBTN"
                                onClick={addCourtRow}
                              >
                                {" "}
                                <i
                                  className="fa fa-plus-circle"
                                  aria-hidden="true"
                                ></i>
                              </span>
                              <span
                                className="px-1 RemoveBTN"
                                onClick={() =>
                                  removeCourtRow(newsdetails.length - 1)
                                }
                              >
                                <i
                                  className="fa fa-minus-circle"
                                  aria-hidden="true"
                                ></i>
                              </span>{" "}
                              )
                            </div>
                          </div>
                          <div className="col-lg-12">
                            {newsdetails.map((row, index) => (
                              <div key={index} className="row newsDeatilsRow">
                                <div className="form-group col-lg-12 col-md-12">
                                  <label htmlFor="adsFormate" className="mb-2">
                                    Ads Formate{" "}
                                    <span className="mx-2 ">
                                      ( Line: {row.lines}, Words: {row.words} )
                                    </span>
                                  </label>
                                  <textarea
                                    id="adsFormate"
                                    name="adsFormate"
                                    value={row.adsFormate}
                                    onChange={(e) =>
                                      handleInputChange(
                                        index,
                                        "adsFormate",
                                        e.target.value
                                      )
                                    }
                                    rows={3}
                                    className="form-control"
                                    required
                                  />
                                </div>
                              </div>
                            ))}
                          </div>

                          <div className="form-group col-lg-12 col-md-12 mb-3">
                            <label>Description</label>
                            <textarea
                              value={description}
                              onChange={(e) => setdescriptions(e.target.value)}
                              rows={4}
                              className="form-control"
                            />
                          </div>
                        </div>

                        <div className="col-lg-12 col-md-12 text-center mt-3">
                          <button className="theme-btn btn-style-three submitbtn">
                            Submit
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <div className="deshboard_footer">
          <DeshBoardFooter RendomTokenfetch={RendomTokenfetch} />
        </div>
      </div>
    </>
  );
}
